export const gameType = {
  LIPSTICK_TRYON: 'LIPSTICK_TRYON',
  WATCH_TRYON: 'WATCH_TRYON',
  SHOE_TYRON: 'SHOE_TYRON',
  PALM_TRYON: 'PALM_TRYON',
  RING_TRYON: 'RING_TRYON',
  FACE_TRYON: 'FACE_TRYON',
  BODY_TRYON: 'BODY_TRYON',
  GLASS_TRYON: 'GLASS_TRYON',
  HAT_TRYON: 'HAT_TRYON',
};

export const gameCategory = {
  TRYON: 'TRYON',
  MARKERLESS: 'MARKERLESS',
  MARKERBASED: 'MARKERBASED',
  FACE_TRYON: 'FACE_TRYON',
  GAME: 'GAME',
  AROUND: 'AROUND',
  IMAGE_TRACKING: 'IMAGE_TRACKING',
};

export const gameTypes = {
  CATCHER: 'CATCHER',
  QUEST: 'QUEST',
  RISE_BURST: 'RISE_BURST',
};
